import React, {Component} from "react";
import ErrorAction from "../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import Container from "../../../../modules/commons/Container";
import {fetchDataAsync} from "../../../../Services/Utils";
import Api from "../../../../Services/Api";
import {mapToObjectDDL} from "../../../common/mapper";
import * as R from "ramda";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import FlexView from "react-flexview";
import SimpleCheckBox from "../../../../modules/SimpleCheckBox";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import MonitoringDailyUnitProfit from "./components/monitoringDailyUnitProfit";
import MonitoringMonthlyUnitProfit from "./components/monitoringMonthlyUnitProfit";

class DashboardAccounting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            subMenuVisible: false, // todo change to true
            isAllSelected: false,
            isSpecificSelected: false,
            dataCabang: [],
            kodeCabang: [],
            search: [],
        };
    };

    componentDidMount() {
        this.fetchDataCabang();
    }

    componentDidUpdate = async (prevProps, prevState, snapshot) => {
        if (prevState.subMenuVisible !== this.state.subMenuVisible && this.state.subMenuVisible === false) {
            await this.fetchDataCabang();
        }
    };

    fetchDataCabang = async () => {
        this.handleTriggerLoading();
        try {
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
                setError: this.props.setError,
                menuName: "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Cabang",
                args: null,
            });
            if (res.ok) {
                let filteredData = res.data.data.filter(
                    item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
                );

                if (filteredData.length !== 0) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        dataCabang: filteredData,
                    }));
                }
            }
        } catch (error) {
            console.log("errors", error);
        }
        this.handleTriggerLoading();
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({...prevValue, loading: !prevValue.loading}));
    };

    handleSelectCabang = (e, type) => {
        const isChecked = e.target.checked;

        if (type === "ALL") {
            this.setState((prevValue) => ({
                ...prevValue,
                isAllSelected: isChecked,
                isSpecificSelected: false,
                kodeCabang: [],
            }));
        }

        if (type === "SPECIFIC") {
            this.setState((prevValue) => ({
                ...prevValue,
                isSpecificSelected: isChecked,
                isAllSelected: false,
                kodeCabang: [],
            }));
        }
    };

    handleChangeCabang = (value) => {
        this.setState((prevValue) => ({...prevValue, kodeCabang: value}));
    };

    handleSearch = () => {
        const {dataCabang, kodeCabang, isAllSelected, isSpecificSelected} = this.state;
        this.setState((prevValue) => ({
            ...prevValue,
            search: isAllSelected
                ? dataCabang.map(item => item.kodeCabang)
                : isSpecificSelected && !R.isEmpty(kodeCabang)
                    ? kodeCabang.map(item => item.value)
                    : [],
        }));
    };

    handleSubMenuVisibility = () => {
        this.setState((prevValue) => ({...prevValue, subMenuVisible: !prevValue.subMenuVisible}));
    };

    render() {
        let {search} = this.state;
        return (
            <>
                <Container>
                    {this.state.subMenuVisible && (
                        <div
                            className="content"
                            style={{
                                borderWidth: 2,
                                borderColor: "#000000",
                                backgroundColor: "#E74C3C",
                                borderStyle: "solid",
                                borderRadius: 5,
                                width: 235,
                                height: 235,
                                justifyContent: "space-evenly",
                            }}
                            onClick={this.handleSubMenuVisibility}
                        >
                            <div
                                className="list"
                                style={{
                                    marginTop: "35%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: "#ffffff",

                                    alignContent: "center",
                                }}
                            >
                                <div className="icn" style={{marginRight: 10}}>
                                    <i className={`fa fa-lg fa-tv fa-lg`}></i>
                                </div>
                                <div className="ttl">{"Monitoring Profit"}</div>
                                <div className="icn icn-right txt-site txt-right txt-12"/>
                            </div>
                        </div>
                    )}
                    {!this.state.subMenuVisible && (
                        <>
                            <FlexView style={{gap: "20px", alignItems: "center"}}>
                                <SimpleCheckBox
                                    id="reportAllCabang"
                                    key="reportAllCabang"
                                    name="reportAllCabang"
                                    label="ALL CABANG"
                                    checked={this.state.isAllSelected}
                                    onChange={(e) => this.handleSelectCabang(e, "ALL")}
                                />
                                <SimpleCheckBox
                                    id="reportSpecificCabang"
                                    key="reportSpecificCabang"
                                    name="reportSpecificCabang"
                                    label="SPESIFIK CABANG"
                                    checked={this.state.isSpecificSelected}
                                    onChange={(e) => this.handleSelectCabang(e, "SPECIFIC")}
                                />
                                <SimpleDDL
                                    id="select_options_kode_cabang"
                                    box="multiselect"
                                    name="kodeCabang"
                                    containerclassname="width width-500px margin-top-15px"
                                    placeholder="Nama Cabang"
                                    readOnly={!this.state.isSpecificSelected}
                                    options={
                                        this.state.dataCabang.map(
                                            item => mapToObjectDDL(item.namaDealer, item.kodeCabang)
                                        )
                                    }
                                    value={this.state.kodeCabang}
                                    onChange={(value) => this.handleChangeCabang(value)}
                                />
                                <SimpleButton onClick={this.handleSearch}>Cari</SimpleButton>
                            </FlexView>
                            <Tabs>
                                <TabList>
                                    <Tab>Monitoring Profit Unit Bruto Harian</Tab>
                                    <Tab>Monitoring Profit Unit Bruto Rata-Rata By Tipe Per Bulan</Tab>
                                </TabList>
                                <TabPanel>
                                    <MonitoringDailyUnitProfit
                                        {...this.props}
                                        listCabang={search}
                                        triggerLoading={this.handleTriggerLoading}
                                    />
                                </TabPanel>
                                <TabPanel>
                                    <MonitoringMonthlyUnitProfit
                                        {...this.props}
                                        listCabang={search}
                                        triggerLoading={this.handleTriggerLoading}
                                    />
                                </TabPanel>
                            </Tabs>
                        </>
                    )}
                </Container>
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(DashboardAccounting);